export enum NotificationsTitle {
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}
